var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "t-records",
    attrs: {
      "id": "allrecords",
      "data-tilda-export": "yes",
      "data-hook": "blocks-collection-content-node",
      "data-tilda-project-id": "1933100",
      "data-tilda-page-id": "11364889",
      "data-tilda-page-alias": "ready",
      "data-tilda-formskey": "00da022453d7435b7731ad57b717c0d2"
    }
  }, [_c('div', {
    staticClass: "r t-rec",
    attrs: {
      "id": "rec191612788",
      "data-animationappear": "off",
      "data-record-type": "396"
    }
  }, [_c('div', {
    staticClass: "t396"
  }, [_c('div', {
    staticClass: "t396__artboard",
    attrs: {
      "data-artboard-recid": "191612788",
      "data-artboard-height": "640",
      "data-artboard-height_vh": "100",
      "data-artboard-valign": "center",
      "data-artboard-ovrflw": ""
    }
  }, [_c('div', {
    staticClass: "t396__elem tn-elem tn-elem__1916127881589478976229",
    attrs: {
      "data-elem-id": "1589478976229",
      "data-elem-type": "shape",
      "data-field-top-value": "198",
      "data-field-top-res-960-value": "140",
      "data-field-top-res-640-value": "158",
      "data-field-top-res-480-value": "111",
      "data-field-top-res-320-value": "178",
      "data-field-left-value": "523",
      "data-field-left-res-960-value": "415",
      "data-field-left-res-640-value": "253",
      "data-field-left-res-480-value": "175",
      "data-field-left-res-320-value": "142",
      "data-field-height-value": "10",
      "data-field-width-value": "10",
      "data-field-axisy-value": "top",
      "data-field-axisx-value": "left",
      "data-field-container-value": "grid",
      "data-field-topunits-value": "",
      "data-field-leftunits-value": "",
      "data-field-heightunits-value": "",
      "data-field-widthunits-value": "",
      "data-animate-mobile": "y",
      "data-animate-sbs-event": "intoview",
      "data-animate-sbs-trg": "1",
      "data-animate-sbs-trgofst": "0",
      "data-animate-sbs-loop": "loop",
      "data-animate-sbs-opts": "[{'ti':'0','mx':'0','my':'0','sx':'1','sy':'1','op':'1','ro':'0','bl':'0','ea':'','dt':'0'},{'ti':200,'mx':'0','my':'0','sx':'1','sy':'1','op':0.5,'ro':'0','bl':'0','ea':'','dt':'0'},{'ti':200,'mx':'0','my':'0','sx':'1','sy':'1','op':1,'ro':'0','bl':'0','ea':'','dt':'0'},{'ti':200,'mx':'0','my':'0','sx':'1','sy':'1','op':0.5,'ro':'0','bl':'0','ea':'','dt':'0'},{'ti':200,'mx':0,'my':-5,'sx':'1','sy':'1','op':1,'ro':'0','bl':'0','ea':'easeIn','dt':'0'},{'ti':200,'mx':0,'my':0,'sx':'1','sy':'1','op':0.5,'ro':'0','bl':'0','ea':'easeOut','dt':'0'}]"
    }
  }, [_c('div', {
    staticClass: "tn-atom"
  })]), _c('div', {
    staticClass: "t396__elem tn-elem tn-elem__1916127881589479588906",
    attrs: {
      "data-elem-id": "1589479588906",
      "data-elem-type": "shape",
      "data-field-top-value": "198",
      "data-field-top-res-960-value": "140",
      "data-field-top-res-640-value": "158",
      "data-field-top-res-480-value": "111",
      "data-field-top-res-320-value": "178",
      "data-field-left-value": "538",
      "data-field-left-res-960-value": "430",
      "data-field-left-res-640-value": "268",
      "data-field-left-res-480-value": "190",
      "data-field-left-res-320-value": "157",
      "data-field-height-value": "10",
      "data-field-width-value": "10",
      "data-field-axisy-value": "top",
      "data-field-axisx-value": "left",
      "data-field-container-value": "grid",
      "data-field-topunits-value": "",
      "data-field-leftunits-value": "",
      "data-field-heightunits-value": "",
      "data-field-widthunits-value": "",
      "data-animate-mobile": "y",
      "data-animate-sbs-event": "intoview",
      "data-animate-sbs-trg": "1",
      "data-animate-sbs-trgofst": "0",
      "data-animate-sbs-loop": "loop",
      "data-animate-sbs-opts": "[{'ti':'0','mx':'0','my':'0','sx':'1','sy':'1','op':'1','ro':'0','bl':'0','ea':'','dt':'0'},{'ti':200,'mx':'0','my':'0','sx':'1','sy':'1','op':0.5,'ro':'0','bl':'0','ea':'','dt':100},{'ti':200,'mx':'0','my':'0','sx':'1','sy':'1','op':1,'ro':'0','bl':'0','ea':'','dt':'0'},{'ti':200,'mx':'0','my':'0','sx':'1','sy':'1','op':0.5,'ro':'0','bl':'0','ea':'','dt':'0'},{'ti':200,'mx':0,'my':-5,'sx':'1','sy':'1','op':1,'ro':'0','bl':'0','ea':'easeIn','dt':'0'},{'ti':200,'mx':0,'my':0,'sx':'1','sy':'1','op':0.5,'ro':'0','bl':'0','ea':'easeOut','dt':'0'}]"
    }
  }, [_c('div', {
    staticClass: "tn-atom"
  })]), _c('div', {
    staticClass: "t396__elem tn-elem tn-elem__1916127881589479590371",
    attrs: {
      "data-elem-id": "1589479590371",
      "data-elem-type": "shape",
      "data-field-top-value": "198",
      "data-field-top-res-960-value": "140",
      "data-field-top-res-640-value": "158",
      "data-field-top-res-480-value": "111",
      "data-field-top-res-320-value": "178",
      "data-field-left-value": "553",
      "data-field-left-res-960-value": "445",
      "data-field-left-res-640-value": "283",
      "data-field-left-res-480-value": "205",
      "data-field-left-res-320-value": "172",
      "data-field-height-value": "10",
      "data-field-width-value": "10",
      "data-field-axisy-value": "top",
      "data-field-axisx-value": "left",
      "data-field-container-value": "grid",
      "data-field-topunits-value": "",
      "data-field-leftunits-value": "",
      "data-field-heightunits-value": "",
      "data-field-widthunits-value": "",
      "data-animate-mobile": "y",
      "data-animate-sbs-event": "intoview",
      "data-animate-sbs-trg": "1",
      "data-animate-sbs-trgofst": "0",
      "data-animate-sbs-loop": "loop",
      "data-animate-sbs-opts": "[{'ti':'0','mx':'0','my':'0','sx':'1','sy':'1','op':'1','ro':'0','bl':'0','ea':'','dt':'0'},{'ti':200,'mx':'0','my':'0','sx':'1','sy':'1','op':0.5,'ro':'0','bl':'0','ea':'','dt':200},{'ti':200,'mx':'0','my':'0','sx':'1','sy':'1','op':1,'ro':'0','bl':'0','ea':'','dt':'0'},{'ti':200,'mx':'0','my':'0','sx':'1','sy':'1','op':0.5,'ro':'0','bl':'0','ea':'','dt':'0'},{'ti':200,'mx':0,'my':-5,'sx':'1','sy':'1','op':1,'ro':'0','bl':'0','ea':'easeIn','dt':'0'},{'ti':200,'mx':0,'my':0,'sx':'1','sy':'1','op':0.5,'ro':'0','bl':'0','ea':'easeOut','dt':'0'}]"
    }
  }, [_c('div', {
    staticClass: "tn-atom"
  })])])])])]);
}]

export { render, staticRenderFns }